import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Dialog, DialogTitle, DialogContent, CircularProgress, Fade, DialogActions, Grid } from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import FileUpload from "../Files/Upload";
import PrimaryButton from "../Global/Buttons/PrimaryButton";
import { updateLoanDetailsFromSpreadsheet, clearUploadErrors } from "../../store/state/loan/loanDetails";

const Spacer = styled.div`
  flex-grow: 1;
`;

const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom: 15px;
`;

const ValidationGrid = styled(Grid)`
  && {
    height: 264px;
  }
`;

const ValidationComment = styled.div`
  color: rgba(0, 0, 0, 0.537);
`;

const StyledCancelButton = styled(PrimaryButton)`
  &&& {
    margin-right: 12px;
  }
`;

export const VerticalDivider = styled.div`
  height: 100%;
  border-right: 1px solid #cccccc;
`;

const Error = styled.div`
  color: #ff0000;
  font-size: 17px;
  padding-left: 8px;
`;

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
`;

const styles = () => ({
  customPaperWidthMd: {
    maxWidth: "780px",
    minWidth: "750px"
  }
});

class UploadSpreadsheetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  close = extract => {
    this.props.onClose(extract);
    this.props.clearUploadErrors();
  };

  static getDerivedStateFromProps(props, state) {
    /*
     * NOTE:  This seems kind of hackish to me so if someone has a better way of doing this, please feel free to change my code.  All I ask is
     *        that you let me know so I can learn from it.  Thanks! -- Jonathan Byrne 03/03/2020
     */
    if (props.uploadSuccessful && !state.uploadHandled) {
      state.uploadHandled = true;
      props.clearUploadErrors();
      props.onClose(true);
    }
    if (!props.uploadSuccessful && state.uploadHandled) {
      state.uploadHandled = undefined;
    }
  }

  render() {
    const { classes, isOpen, errorMessage, showSpinner } = this.props;
    return (
      <Dialog
        classes={{
          paperWidthMd: classes.customPaperWidthMd
        }}
        open={isOpen}
        onClose={() => this.close(false)}
        maxWidth="sm"
      >
        <Grid container alignItems="center" justify="space-between">
          <DialogTitle>Import Loan Abstract</DialogTitle>
          <IconButton style={{ marginRight: 16 }} onClick={() => this.close(false)}>
            <CloseIcon style={{ fontSize: 36 }} />
          </IconButton>
        </Grid>
        <DialogContent>
          {!showSpinner && (
            <Grid container direction="column" spacing={8} justify="space-between">
              <Grid item>
                <Description>Choose an edited template to upload:</Description>
              </Grid>
              <Grid item>
                <FileUpload
                  onDrop={files => {
                    this.props.updateLoanDetailsFromSpreadsheet(this.props.loanId, files[0]);
                  }}
                />
              </Grid>
            </Grid>
          )}
          {showSpinner && (
            <ValidationGrid direction="column" container justify="center" alignItems="center" spacing={16}>
              <Grid item>
                <CircularProgress size={120} thickness={1} />
              </Grid>
              <Grid item>
                <ValidationComment>Validating file...</ValidationComment>
              </Grid>
            </ValidationGrid>
          )}
        </DialogContent>
        <StyledDialogActions>
          <Fade in={!!errorMessage}>
            <Error>{errorMessage}</Error>
          </Fade>
          <Spacer />
          <StyledCancelButton onClick={() => this.close(false)}>Cancel</StyledCancelButton>
        </StyledDialogActions>
      </Dialog>
    );
  }
}

UploadSpreadsheetModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  loanId: PropTypes.number.isRequired
};

const mapStateToProps = ({ loanDetails }) => ({
  errorMessage: loanDetails.uploadErrorMessage,
  showSpinner: loanDetails.showSpinner,
  uploadSuccessful: loanDetails.uploadSuccessful
});

export default compose(
  withRouter,
  connect(mapStateToProps, { updateLoanDetailsFromSpreadsheet, clearUploadErrors }),
  withStyles(styles)
)(UploadSpreadsheetModal);
